import { useState } from 'react'
import Button from '../components/ui/Button'
import '../styles/pages/top.scss'
import ReactPlayer from 'react-player'

const Top = () => {
    const [thumbnail, hideThumbnail] = useState(false)
    return (
        <div className='page-container'>
            <Hero />
            <div className='captcha-banner'>
                <h1>A hero's duty, a city's fate.</h1>
            </div>
            <div className='video-container'>
                <div className='video-wrapper'>
                    {thumbnail ? (
                        // <ReactPlayer url='https://www.youtube.com/watch?v=8dssaQuEAiY' />
                        <ReactPlayer url='https://www.youtube.com/watch?v=XHpTVUikuO0' />
                    ) : (
                        // <div className='youtube-thumb-wrapper'>
                        //      <img
                        //         src='./img/play.png'
                        //         alt='The Legend of Heroes Trails From Azure Announcement Trailer'
                        //         className='youtube-play'
                        //         onClick={() => {
                        //             hideThumbnail(true)
                        //         }}
                        //     />
                        //     <img
                        //         src='./img/azure-trailer-thumb.webp'
                        //         alt='The Legend of Heroes Trails From Azure Announcement Trailer'
                        //         className='youtube-thumb'
                        //         onClick={() => {
                        //             hideThumbnail(true)
                        //         }}
                        //     />
                        // </div>
                        <div className='youtube-thumb-wrapper'>
                             <img
                             src='./img/play.png'
                             alt='The Legend of Heroes Trails From Azure Announcement Trailer'
                             className='youtube-play'
                             onClick={() => {
                                 hideThumbnail(true)
                             }}
                         />
                         <img
                             src='./img/rda_trailer_thumb.webp'
                             alt='The Legend of Heroes Trails From Azure Announcement Trailer'
                             className='youtube-thumb'
                             onClick={() => {
                                 hideThumbnail(true)
                             }}
                         />
                     </div>
                    )}
                </div>{' '}
                <h2 className='product-availablenow'>Release Date Announcement Trailer</h2>
            </div>
            <Specs />
        </div>
    )
}

const Hero = () => (
    <header className='hero-container'>
        <section className='hero-left'></section>
        <section className='hero-right'>
            <img src='./img/azure_logo_rda.png' alt='Trails from Azure Logo' />
            {/* <h1>
                Coming Fall 2026 to <br /> Nintendo Switch™2 and PlayStation®5
            </h1>{' '}
            <h1>
                Available now on <br /> Nintendo Switch™, PlayStation®4, and PC
            </h1> */}
            <a
                href='https://store.nisamerica.com/the-legend-of-heroes-trails-to-azure'
                target='_blank'
                rel='noopener noreferrer'
            ></a>
        </section>
    </header>
)

const Specs = () => (
    <div className='specs-container'>
        <div className='specs-wrapper'>
            <div className='border'>
                <h1 className='specs-title'>SPECS</h1>
                <table className='spec-table'>
                    <tbody>
                        <tr>
                            <th>Title:</th>
                            <td>The Legend of Heroes: Trails to Azure</td>
                        </tr>
                        <tr>
                            <th>Release:</th>
                            <td>
                            September 10 (Nintendo Switch™2 and PlayStation®5) <br />
                                Available now (Nintendo Switch™, PlayStation®4, and PC)
                            </td>
                        </tr>
                        <tr>
                            <th>Platform(s):</th>
                            <td>Nintendo Switch™2, Nintendo Switch™, PlayStation®5, PlayStation®4. PC</td>
                        </tr>
                        <tr>
                            <th>Player(s):</th>
                            <td>1</td>
                        </tr>
                        <tr>
                            <th>Genre:</th>
                            <td>RPG</td>
                        </tr>
                        <tr>
                            <th>Audio:</th>
                            <td>Japanese</td>
                        </tr>
                        <tr>
                            <th>Text:</th>
                            <td>English</td>
                        </tr>
                        <tr>
                            <th>Developer:</th>
                            <td>Nihon Falcom</td>
                        </tr>
                        <tr>
                            <th>Publisher:</th>
                            <td>NIS America, Inc.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
)

export default Top
